import ChevronRight from "@/assets/ChevronRight.svg";
import { getRoute } from "@/functions/getRoute";
import { trimText } from "@/functions/trimText";
import { blog_helper } from "@/helpers/blog_helper";
import { LatestBlogCard, Title, BlogFeedCard } from "@/ui";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { bg } from "date-fns/locale";

export const LatestBlogs = ({ className, title, button, titleColor, bgColor }) => {
  const items = blog_helper.fetch({ limit: 3 });

  return (
    <div className={clsx(className, classes.blogs , `bg-${bgColor}`)}>
      <Container className="mw-xxl">
        <Title title={title} className={clsx(`text-${titleColor}`)} />
        <Row className="mb-md-4">
          {items.map(({ title, image, publish_date, url_slug }, k) => (
            <Col key={k} xs={12} md={4} className="mb-4">
              <BlogFeedCard
                className="h-100"
                title={title}
                img={image}
                published_at={publish_date}
                href={getRoute("blogPost", { url_slug })}
              />
            </Col>
          ))}
        </Row>
        <div className={classes.blogs__footer}>
          {button && (
            <a className={classes.blogs__link} href={button.href}>
              {button.label}
              <ChevronRight width="7" height="13" className="ms-2" />
            </a>
          )}
        </div>
      </Container>
    </div>
  );
};

export default LatestBlogs;
